// extracted by css-extract-rspack-plugin
export default {"Text":"BypassListRow-module__Text__geGSV3v","IconButton":"BypassListRow-module__IconButton__z_SIusl","ActionListItemText":"BypassListRow-module__ActionListItemText__Iw5TuPl"};